import type { LoomPluginOptions, RenderButton } from '@atlaskit/editor-plugin-loom/types';

interface Props {
	options: {
		renderButton: RenderButton;
	};
}

export function loomPluginOptions({ options }: Props): LoomPluginOptions {
	return {
		renderButton: options.renderButton,
		shouldShowToolbarButton: undefined,
	};
}
